import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomCreateAiMappingRunMutation } from "generated/graphql";

export const useCreateAiMappingRun = () => {
  const [mutation, { data, loading, error }] = useCustomCreateAiMappingRunMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "createAiMappingRun" },
    { hideMessage: true }
  );
};
